export function handleFieldChange(fieldState, setter) {

	const fields = (this && this.state && this.state.fields) || fieldState,
		setFields = (this && this.setState) || setter;

	const func = evt => {
		const {name, type, value} = evt.target;
		let fieldVal = value;
		
		// console.log('handleFieldChange', (type==='tel' && !!!this.handlePhoneFieldChange(evt) && value), (type!=='checkbox' && value), !this.state.fields[name])
		if (type==='tel') {
		  fieldVal = handlePhoneFieldChange(value, evt);
		}
		
		if (type==='checkbox') {
		  fieldVal = !fields[name];
		}
	
		// const f = Object.assign(fields, {[name]:fieldVal});
		setFields((prevProps) => ({...prevProps, [name]: fieldVal}));
	}

	return func;
}
 
export function handlePhoneFieldChange(str, evt) {
	//ignore backspace and delete keys
	if (evt.keyCode !== 8 && evt.keyCode !== 46) {
		const val = str.replace(/\D/g,'');
		
	return val.substring(0,3) + '-' + val.substring(3,6) + '-' + val.substring(6,10);
	}
}